import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import AppRouter from './routes/AppRouter';
import { msalInstance } from './features/auth/msalInstance';
import './index.css';
import GlobalLoader from './components/UI/GlobalLoader';
import TokenExpiredDialog from './components/UI/TokenExpiredDialog';
import AuthenticationProgress from './pages/Login/AuthenticationProgress';

const App: React.FC = () => (
  <MsalProvider instance={msalInstance}>
    <GlobalLoader />
    <TokenExpiredDialog />
    <AuthenticationProgress />
    <AppRouter />
  </MsalProvider>
);

export default App;
